import Vue from 'vue'

Vue.filter('real', function(value){
    return parseFloat(Math.round(value * 100) / 100).toFixed(2)
})



// WEBPACK FOOTER //
// ./resources/assets/js/filters/numeric.js